import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatDateTime } from "@/lib/helpers";

// Parent Dashboard -> reschedule-an-existing-lesson dialog. Extracted from
// ParentDashboard.js (props-driven, no behavior change).
export const RescheduleRequestDialog = ({ open, target, form, onFormChange, onOpenChange, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="reschedule-request-dialog">
      <DialogHeader>
        <DialogTitle>Request a Reschedule</DialogTitle>
      </DialogHeader>
      <div className="space-y-3">
        {target && (
          <p className="text-sm text-muted-foreground" data-testid="reschedule-target-summary">
            {target.student_name} &middot; {formatDateTime(target.start_time)}
          </p>
        )}
        <div className="space-y-1.5">
          <Label>Reason</Label>
          <Textarea
            value={form.reason}
            onChange={(e) => onFormChange((f) => ({ ...f, reason: e.target.value }))}
            placeholder="Let the office know why you need to reschedule"
            data-testid="reschedule-reason-input"
          />
        </div>
        <div className="space-y-1.5">
          <Label>Preferred new time (optional)</Label>
          <Input
            value={form.preferred_time}
            onChange={(e) => onFormChange((f) => ({ ...f, preferred_time: e.target.value }))}
            placeholder="e.g. Next Tuesday afternoon"
            data-testid="reschedule-preferred-time-input"
          />
        </div>
      </div>
      <DialogFooter>
        <Button onClick={onSubmit} data-testid="reschedule-request-submit-button">Send Request</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
